import QaCatalogView from "./QaCatalog";
import QaRunPage from "./QaRunPage";
import QaTestRuns from "./QaTestRuns";
import type { QaTab } from "../lib/route";

type Props = {
  project: string;
  /** Display name for the project; the header falls back to the id when unknown. */
  projectName?: string;
  /** The test run open on its own page; null shows the project's list of runs. */
  runId?: string | null;
  onOpenRun?: (id: string | null) => void;
  /** Test runs, or every test the repo has (the catalog). */
  tab?: QaTab;
  onTab?: (tab: QaTab) => void;
  onClose: () => void;
};

// A project's QA tests: its test runs on the qa-agent runners and the Run tests
// button, each run on its own page, and the Tests tab with every test in the
// repo. Lives on its own route (/qa/<project>, /qa/<project>/tests,
// /qa/<project>/runs/<run>) so a hard reload, or a link from a GitHub check or
// PR comment, lands straight on it.
export default function QaPage({ project, projectName, runId = null, onOpenRun = () => {}, tab = "runs", onTab = () => {}, onClose }: Props) {
  if (runId) {
    return (
      <div className="qa-page qa-page-wide">
        <QaRunPage project={project} projectName={projectName ?? project} runId={runId} onBack={onClose} />
      </div>
    );
  }
  return (
    <div className="qa-page">
      <header className="qa-page-header">
        <button type="button" className="qa-page-back" onClick={onClose} aria-label="Back to QA projects">←</button>
        <h1>QA tests · {projectName ?? project}</h1>
      </header>
      <nav className="qo-subnav" aria-label="QA views">
        <button type="button" className={tab === "runs" ? "on" : ""} aria-current={tab === "runs" ? "page" : undefined} onClick={() => onTab("runs")}>Test runs</button>
        <button type="button" className={tab === "tests" ? "on" : ""} aria-current={tab === "tests" ? "page" : undefined} onClick={() => onTab("tests")}>Tests</button>
      </nav>
      {tab === "tests" ? <QaCatalogView project={project} /> : <QaTestRuns project={project} onOpenRun={(id) => onOpenRun(id)} />}
    </div>
  );
}
